module.exports = __webpack_public_path__ + "static/media/Nguyen_Xuan_Anh.9148de58.jpeg";